import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormLabel from '@mui/material/FormLabel';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import FormControlLabel from '@mui/material/FormControlLabel';

import {
  selectMultipleChoiceOption,
  getCampaignElementById,
} from '../../../redux/modules/campaignLandingPage';

const VpMultipleChoice = ({ qid, element, _selectMultipleChoiceOption }) => {
  const { description, label } = element;
  const options = description?.split(',') || [];

  return (
    <Stack sx={{ maxWidth: '600px', my: '10px', fontFamily: 'Roboto' }}>
      <div>
        <FormLabel
          sx={{
            fontWeight: 700,
            mb: '10px',
            color: 'black',
            fontSize: '14px',
          }}
          id="demo-radio-buttons-group-label"
        >
          {label}
        </FormLabel>
        {element.required && (
          <span style={{ display: 'inline-block', color: 'var(--primary-600)', marginLeft: '4px' }}>
            *
          </span>
        )}
      </div>

      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={(e) => _selectMultipleChoiceOption(qid, e.target.value)}
      >
        {options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={<Radio />}
            label={<Typography variant="checkboxLabel">{option}</Typography>}
          />
        ))}
      </RadioGroup>
    </Stack>
  );
};

VpMultipleChoice.propTypes = {
  qid: PropTypes.number.isRequired,
  element: PropTypes.object.isRequired,
  _selectMultipleChoiceOption: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
  element: getCampaignElementById(state, ownProps.qid),
});

const mapDispatchToProps = {
  _selectMultipleChoiceOption: selectMultipleChoiceOption,
};

export default connect(mapStateToProps, mapDispatchToProps)(VpMultipleChoice);



// WEBPACK FOOTER //
// ./src/vp-ui/components/MultipleChoice/MultipleChoice.jsx